var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOutlook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.173,
    height: 104.313,
    x: 0,
    y: 0,
    viewBox: "0 0 103.173 104.313",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0072c6",
    d: "M64.567 22.116v20.405l7.13 4.49c.188.054.596.058.784 0l30.688-20.69c0-2.45-2.284-4.205-3.573-4.205h-35.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0072c6",
    d: "M64.567 50.133l6.507 4.47c.917.674 2.022 0 2.022 0-1.101.674 30.077-20.036 30.077-20.036V72.07c0 4.083-2.613 5.795-5.551 5.795h-33.06v-27.73z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0072c6",
    transform: "translate(-13.481 -41.384) scale(3.91787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.321 20.958c-.566 0-1.017.266-1.35.797-.333.531-.5 1.234-.5 2.109 0 .888.167 1.59.5 2.106.333.517.77.774 1.31.774.557 0 .999-.251 1.325-.753.326-.502.49-1.199.49-2.09 0-.929-.158-1.652-.475-2.169-.317-.516-.75-.774-1.3-.774z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.441 13.563v20.375l15.5 3.25V10.563l-15.5 3zm10.372 13.632c-.655.862-1.509 1.294-2.563 1.294-1.027 0-1.863-.418-2.51-1.253-.646-.836-.97-1.924-.97-3.266 0-1.417.328-2.563.985-3.438s1.527-1.313 2.61-1.313c1.023 0 1.851.418 2.482 1.256.632.838.948 1.942.948 3.313.001 1.409-.327 2.545-.982 3.407z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlook);
export default __webpack_public_path__ + "static/media/icon-outlook.b2593d269c23fa7fa1d650f7ab950fc6.svg";
export { ForwardRef as ReactComponent };